import React from 'react';
import { Minus, Plus } from 'lucide-react';
interface QuantityStepperProps {
  quantity: number;
  onChange: (newQuantity: number) => void;
  min?: number;
}
export const QuantityStepper = ({
  quantity,
  onChange,
  min = 0
}: QuantityStepperProps) => {
  return <div className="flex items-center bg-cream-dark rounded-full p-1 border border-border" data-id="element-47">
      <button onClick={() => onChange(Math.max(min, quantity - 1))} disabled={quantity <= min} className="p-1.5 rounded-full text-espresso hover:bg-white disabled:opacity-30 transition-colors" aria-label="Decrease quantity" data-id="element-48">
        <Minus size={16} strokeWidth={2.5} data-id="element-49" />
      </button>
      <span className="w-8 text-center font-medium text-espresso text-sm" data-id="element-50">
        {quantity}
      </span>
      <button onClick={() => onChange(quantity + 1)} className="p-1.5 rounded-full text-espresso hover:bg-white transition-colors" aria-label="Increase quantity" data-id="element-51">
        <Plus size={16} strokeWidth={2.5} data-id="element-52" />
      </button>
    </div>;
};